import HTTPClient from '@/common/http-client';
import { AxiosInstance } from 'axios';

export default class BaseService {
  //TODO: Move instance to func
  protected HTTP: AxiosInstance = HTTPClient.getInstance().HTTP;
  protected HTTP_WITH_DELAYED_MSG: AxiosInstance = HTTPClient.getInstance().HTTP_WITH_DELAYED_MSG;
  protected HTTP_WITH_DELAYED_SUCCESS_MSG: AxiosInstance = HTTPClient.getInstance().HTTP_WITH_DELAYED_SUCCESS_MSG;
  protected HTTP_WITHOUT_MSG: AxiosInstance = HTTPClient.getInstance().HTTP_WITHOUT_MSG;
}
